<!-- 组件说明 -->
<template>
  <div class="">
    <van-count-down :time="noDisposeTime">
      <template #default="timeData">
        <span class="count-down" :style="{ backgroundImage: `url(${img})` }">{{
          formatTime(timeData.hours)[0]
        }}</span>
        <span class="count-down" :style="{ backgroundImage: `url(${img})` }">{{
          formatTime(timeData.hours)[1]
        }}</span>
        <span>:</span>
        <span class="count-down" :style="{ backgroundImage: `url(${img})` }">{{
          formatTime(timeData.minutes)[0]
        }}</span>
        <span class="count-down" :style="{ backgroundImage: `url(${img})` }">{{
          formatTime(timeData.minutes)[1]
        }}</span>
        <!-- <span>:</span>
        <span class="count-down" :style="{ backgroundImage: `url(${img})` }">{{
          formatTime(timeData.seconds)[0]
        }}</span>
        <span class="count-down" :style="{ backgroundImage: `url(${img})` }">{{
          formatTime(timeData.seconds)[1]
        }}</span> -->
        <span class="notice" @click.stop="notice(followItem.id)">提醒</span>
      </template>
    </van-count-down>
  </div>
</template>

<script>
import { CountDown as VanCountDown, Toast } from "vant";
export default {
  props: {
    followItem: {
      type: Object,
    },
    noDisposeTime: Number,
  },
  components: { VanCountDown },
  data() {
    return {
      img: require("@/common/images/recommend/count-down.png"),
    };
  },
  computed: {},
  methods: {
    // 时间格式化
    formatTime(time) {
      if (time >= 10) {
        return String(time);
      } else {
        return [0, time];
      }
    },
    // 提醒功能
    notice(id) {
      this.$api
        .remind({ recommendId: id })
        .then((res) => {
          if (res.body !== "fail") {
            Toast.success("提醒成功");
          } else {
            Toast.fail("提醒失败");
          }
        })
        .catch(() => {
          Toast.fail("提醒失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.count-down {
  background-size: 30px 42px;
  width: 30px;
  height: 42px;
  display: inline-block;
  text-align: center;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 42px;
}
.notice {
  margin-left: 20px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #0d9869;
}
</style>
